import React from 'react';
import Animated, { useAnimatedStyle, interpolate, Extrapolation, } from 'react-native-reanimated';
import { Gesture, GestureDetector, Pressable, } from 'react-native-gesture-handler';
import { withTheme } from '@rneui/themed';
import { Row } from '../elements';
import { PlayButton } from './PlayButton';
import { Info } from './Info';
import { Image } from '../shared';
export const UnthemedMiniPlayer = ({ position, image = '', name = '', onTogglePlayer, isPlayButtonEnabled = true, miniplayerHeight = 60, containerStyle = {}, playButtonStyle = {}, trackTitleStyle = {}, titleTouchableStyle = {}, trackTitleContainerStyle = {}, buttonContainerStyle = {}, playButtonContainerStyle = {}, ImageOverlayComponent }) => {
    const tap = Gesture.Tap();
    const headerStyle = useAnimatedStyle(() => {
        const height = interpolate(position.value, [0, 0.25], [miniplayerHeight, 0], Extrapolation.CLAMP);
        return { height };
    });
    const heightAndOpacityStyle = useAnimatedStyle(() => {
        const height = interpolate(position.value, [1, 0], [1, miniplayerHeight], Extrapolation.CLAMP);
        const opacity = interpolate(position.value, [1, 0.75], [0, 1], Extrapolation.CLAMP);
        return {
            width: '100%',
            height,
            opacity,
        };
    });
    return (React.createElement(GestureDetector, { gesture: tap },
        React.createElement(Animated.View, { style: [heightAndOpacityStyle, headerStyle] },
            React.createElement(Row, { style: containerStyle },
                React.createElement(Animated.View, { style: buttonContainerStyle },
                    React.createElement(Pressable, { onPress: onTogglePlayer },
                        React.createElement(Animated.View, null,
                            React.createElement(Image, { uri: image, heightConstraint: miniplayerHeight }),
                            ImageOverlayComponent ? (React.createElement(Animated.View, { style: {
                                    position: 'absolute',
                                    width: '100%',
                                    height: '100%',
                                    backgroundColor: '#000000C0',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                } }, ImageOverlayComponent)) : null))),
                React.createElement(Animated.View, { style: trackTitleContainerStyle },
                    React.createElement(Info, { name: name, onPress: onTogglePlayer, style: trackTitleStyle })),
                isPlayButtonEnabled ? (React.createElement(Animated.View, { style: buttonContainerStyle },
                    React.createElement(PlayButton, { playIconName: "play", pauseIconName: "pause", iconStyle: playButtonStyle, containerStyle: playButtonContainerStyle }))) : null))));
};
export const MiniPlayer = withTheme(UnthemedMiniPlayer, 'MiniPlayer');
//# sourceMappingURL=MiniPlayer.js.map